export const types = {
  LOCATION_CHANGED: "ROUTER/LOCATION_CHANGED",
}
